import { ReactNode } from 'react'

import { FooterContainer } from './styles'

interface IFooterProps {
  children: ReactNode
}

export function Container({ children }: IFooterProps) {
  return <FooterContainer>{children}</FooterContainer>
}
